module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meetingplan-view"
  }, [_c('div', {
    staticClass: "field-block"
  }, [_c('div', {
    staticClass: "field-row field-row-line"
  }, [_c('div', {
    staticClass: "field-title field-title-meetingName"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.meetingName))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('meetingSystem', true)
  }, [_vm._v("系统选择"), _c('common-tooltip', {
    staticClass: "field-input-no-title-tooltip",
    attrs: {
      "isView": "",
      "tipCode": "8"
    }
  }), _c('span', [_vm._v("*")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.basedataGetName('MeetingSystem', _vm.addNewOrEditData.meetingSystem)))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('meetingModality', true)
  }, [_vm._v("是否网络会议"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality)))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('meetingProp', true)
  }, [_vm._v("会议性质"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp)))])]), _vm._v(" "), (_vm.meetingSystemType != 'GSD') ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('meetingType', true)
  }, [_vm._v("A1会议类型"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.basedataGetName('MeetingType', _vm.addNewOrEditData.meetingType)))])]) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.meetingType == '24' && _vm.isCEDepart()) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('isGsd', _vm.addNewOrEditData.meetingType == '24' && _vm.isCEDepart())
  }, [_vm._v("是否为GSD"), _c('span', [_vm._v("*")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field-row field-row-middle"
  }, [_c('mt-radio', {
    staticClass: "radio",
    attrs: {
      "options": _vm.isGsdOptions
    },
    model: {
      value: (_vm.addNewOrEditData.isGsd),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "isGsd", $$v)
      },
      expression: "addNewOrEditData.isGsd"
    }
  })], 1), _vm._v(" "), (_vm.meetingSystemType != 'A1') ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('meetingGsdType', true)
  }, [_vm._v("GSD项目类型"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.basedataGetName('MeetingGsdType', _vm.addNewOrEditData.meetingGsdType)))])]) : _vm._e(), _vm._v(" "), (_vm.meetingSystemType != 'A1') ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('meetingGsdSubType', true)
  }, [_vm._v("GSD细类"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.basedataGetName('MeetingGsdTypeSub' + _vm.addNewOrEditData.meetingGsdType, _vm.addNewOrEditData.meetingGsdSubType)))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "field-block"
  }, [_c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('departId', true)
  }, [_vm._v("部门"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.basedataGetName('Depart', _vm.addNewOrEditData.departId)))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title field-title-more-lines",
    class: _vm.required('medicalField', true)
  }, [_vm._v("Franchise/DA"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.basedataGetName('MedicalField', _vm.addNewOrEditData.medicalField)))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title field-title-more-lines",
    class: _vm.required('medicalField', true)
  }, [_vm._v("团队"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.basedataGetName('Teams', _vm.addNewOrEditData.teamL4)))])]), _vm._v(" "), (_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp) == '推广') ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('treatmentArea', _vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp) == '推广')
  }, [_vm._v("治疗领域"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.basedataGetName('TreatmentArea', _vm.addNewOrEditData.treatmentArea)))])]) : _vm._e(), _vm._v(" "), (_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp) == '非推广') ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('diseaseArea', _vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp).indexOf('非推广') >= 0)
  }, [_vm._v("治疗领域"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.basedataGetName('DiseaseArea', _vm.addNewOrEditData.diseaseArea)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('productId', true)
  }, [_vm._v("产品(多选)"), _c('span', [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-value field-value-left"
  }, [_vm._v(_vm._s(_vm.basedataGetName('Product', _vm.addNewOrEditData.productId)))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('companyStrategy', true)
  }, [_vm._v("公司战略(多选)"), _c('span', [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-value field-value-left"
  }, [_vm._v(_vm._s(_vm.basedataGetName('CompanyStrategy', _vm.addNewOrEditData.companyStrategy)))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('strategyKeynote', true)
  }, [_vm._v("策略重点(多选)"), _c('span', [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-value field-value-left"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.strategyKeynoteName))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('medicalFieldResult', _vm.meetingSystemType != 'A1')
  }, [_vm._v("治疗领域业务结果(多选)"), _c('span', [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-value field-value-left"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.medicalFieldResultName))])]), _vm._v(" "), (_vm.addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title"
  }, [_vm._v("治疗领域业务结果（自定义描述）")])]) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-value field-value-left"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.medicalFieldResultDes))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "field-block"
  }, [_c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('meetingBeginDate', true)
  }, [_vm._v("开始日期"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.meetingBeginDate))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('meetingEndDate', true)
  }, [_vm._v("结束日期"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.meetingEndDate))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('meetingTimeInt', _vm.meetingSystemType != 'GSD')
  }, [_vm._v("会议时段"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.basedataGetName('MeetingTimeInt', _vm.addNewOrEditData.meetingTimeInt)))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('country', _vm.meetingSystemType != 'GSD')
  }, [_vm._v("国家"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.countryName))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('province', _vm.meetingSystemType != 'GSD')
  }, [_vm._v("省份"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.provinceName))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('city', _vm.meetingSystemType != 'GSD')
  }, [_vm._v("城市"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.cityName))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('meetingPlace', _vm.meetingSystemType != 'GSD' && _vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality).indexOf('线下') >= 0)
  }, [_vm._v("会议地点"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.meetingPlace))])])]), _vm._v(" "), _c('div', {
    staticClass: "field-block"
  }, [(_vm.meetingSystemType != 'A1') ? _c('div', [_c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('recipientSocietyOrHospital', _vm.meetingSystemType != 'A1', true)
  }, [_vm._v("受赠方类型"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.recipientSocietyOrHospitalOptions.find(function (r) { return r.value === _vm.recipientSocietyOrHospital; }).label))])])]) : _vm._e(), _vm._v(" "), (_vm.meetingSystemType != 'A1' && _vm.recipientSocietyOrHospital != '0') ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('recipientSocietyStr', true)
  }, [_vm._v("受赠方名称"), _c('common-tooltip', {
    staticClass: "field-input-no-title-tooltip",
    attrs: {
      "isView": "",
      "tipCode": "11"
    }
  }), _c('span', [_vm._v("*")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.recipientSocietyStr || _vm.addNewOrEditData.universityStr || _vm.addNewOrEditData.patientOrgStr || _vm.addNewOrEditData.otherStr))])]) : _vm._e(), _vm._v(" "), ((_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0') && !_vm.isOneHospital()) ? _c('div', [_c('div', {
    staticClass: "field-row field-row-middle"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('moreThenOneHospital', (_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0') && !_vm.isOneHospital())
  }, [_vm._v("医院总数"), _c('span', [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "field-row field-row-middle"
  }, [_c('mt-checklist', {
    staticClass: "radio",
    attrs: {
      "options": _vm.moreThenOneHospitalOptions
    },
    model: {
      value: (_vm.moreThenOneHospitalArray),
      callback: function($$v) {
        _vm.moreThenOneHospitalArray = $$v
      },
      expression: "moreThenOneHospitalArray"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), ((_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0')) ? _c('div', {
    staticClass: "field-row field-row-middle more-tab-div"
  }, [_c('div', {
    staticClass: "more-tab"
  }, [_c('div', {
    staticClass: "field-row-inner"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('hospitalLevelId', _vm.meetingSystemType != 'GSD')
  }, [_vm._v("医院层级"), _c('common-tooltip', {
    staticClass: "field-input-no-title-tooltip",
    attrs: {
      "isView": "",
      "tipCode": "9"
    }
  }), _c('span', [_vm._v("*")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalLevelName))])]), _vm._v(" "), (_vm.moreThenOneHospital == 1 && !_vm.isOneHospital()) ? _c('div', {
    staticClass: "field-row-inner"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('hospitalCount', _vm.meetingSystemType != 'GSD')
  }, [_vm._v("医院数量"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalCount))])]) : _vm._e(), _vm._v(" "), (!(_vm.moreThenOneHospital == 1 && !_vm.isOneHospital())) ? _c('div', {
    staticClass: "field-row-inner"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('hospitalId', (_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0') && !(_vm.moreThenOneHospital == 1 && !_vm.isOneHospital()))
  }, [_vm._v("医院"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalName))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.addNewOrEditData.extendData.hospitalInfos), function(hospital, index) {
    return _c('div', {
      key: index,
      staticClass: "field-row field-row-middle more-tab-div"
    }, [_c('div', {
      staticClass: "more-tab"
    }, [_c('div', {
      staticClass: "field-row-inner"
    }, [_c('div', {
      staticClass: "field-title",
      class: _vm.required('extendData.hospitalInfos.' + index + '.hospitalLevelId', _vm.meetingSystemType != 'GSD')
    }, [_vm._v("医院层级"), _c('common-tooltip', {
      staticClass: "field-input-no-title-tooltip",
      attrs: {
        "isView": "",
        "tipCode": "9"
      }
    }), _c('span', [_vm._v("*")])], 1), _vm._v(" "), _c('div', {
      staticClass: "field-value"
    }, [_vm._v(_vm._s(hospital.hospitalLevelName))])]), _vm._v(" "), _c('div', {
      staticClass: "field-row-inner"
    }, [_c('div', {
      staticClass: "field-title",
      class: _vm.required('extendData.hospitalInfos.' + index + '.hospitalCount', _vm.meetingSystemType != 'GSD')
    }, [_vm._v("医院数量"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
      staticClass: "field-value"
    }, [_vm._v(_vm._s(hospital.hospitalCount))])])])])
  }), _vm._v(" "), ((_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0')) ? _c('div', {
    staticClass: "field-row field-row-top"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('offices', _vm.meetingSystemType != 'GSD')
  }, [_vm._v("科室(多选)"), _c('span', [_vm._v("*")])])]) : _vm._e(), _vm._v(" "), ((_vm.meetingSystemType == 'A1' || _vm.recipientSocietyOrHospital === '0')) ? _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-value field-value-left"
  }, [_vm._v(_vm._s(_vm.basedataGetName('Office', _vm.addNewOrEditData.offices)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('includeSpeaker', true)
  }, [_vm._v("是否包含讲者"), _c('span', [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "field-row field-row-middle"
  }, [_c('mt-checklist', {
    staticClass: "radio",
    attrs: {
      "options": _vm.includeSpeakerOptions
    },
    model: {
      value: (_vm.includeSpeakerArray),
      callback: function($$v) {
        _vm.includeSpeakerArray = $$v
      },
      expression: "includeSpeakerArray"
    }
  })], 1), _vm._v(" "), (_vm.addNewOrEditData.includeSpeaker == 1) ? _c('div', {
    staticClass: "field-block-inner"
  }, [_c('div', {
    staticClass: "field-row field-row-middle more-tab-div"
  }, [_c('div', {
    staticClass: "more-tab"
  }, [_c('div', {
    staticClass: "field-row-inner"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('speakerLevel', _vm.addNewOrEditData.includeSpeaker == 1 && _vm.meetingSystemType != 'GSD')
  }, [_vm._v("讲者级别"), _c('common-tooltip', {
    staticClass: "field-input-no-title-tooltip",
    attrs: {
      "isView": "",
      "tipCode": "10"
    }
  }), _c('span', [_vm._v("*")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.speakerLevelName))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row-inner"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('speakerCount', _vm.addNewOrEditData.includeSpeaker == 1 && _vm.meetingSystemType != 'GSD')
  }, [_vm._v("讲者人数"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.speakerCount))])])])]), _vm._v(" "), _vm._l((_vm.addNewOrEditData.extendData.speakerInfos), function(speaker, index) {
    return _c('div', {
      key: index,
      staticClass: "field-row field-row-middle more-tab-div"
    }, [_c('div', {
      staticClass: "more-tab"
    }, [_c('div', {
      staticClass: "field-row-inner"
    }, [_c('div', {
      staticClass: "field-title",
      class: _vm.required('extendData.speakerInfos.' + index + '.speakerLevel', _vm.addNewOrEditData.includeSpeaker == 1 && _vm.meetingSystemType != 'GSD')
    }, [_vm._v("讲者级别"), _c('common-tooltip', {
      staticClass: "field-input-no-title-tooltip",
      attrs: {
        "isView": "",
        "tipCode": "10"
      }
    }), _c('span', [_vm._v("*")])], 1), _vm._v(" "), _c('div', {
      staticClass: "field-value"
    }, [_vm._v(_vm._s(speaker.speakerLevelName))])]), _vm._v(" "), _c('div', {
      staticClass: "field-row-inner"
    }, [_c('div', {
      staticClass: "field-title",
      class: _vm.required('extendData.speakerInfos.' + index + '.speakerCount', _vm.addNewOrEditData.includeSpeaker == 1 && _vm.meetingSystemType != 'GSD')
    }, [_vm._v("讲者人数"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
      staticClass: "field-value"
    }, [_vm._v(_vm._s(speaker.speakerCount))])])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field-row",
    class: _vm.addNewOrEditData.includeSpeaker == 1 ? 'field-row-top' : ''
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('attendCount', true)
  }, [_vm._v("参会者人数"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.attendCount))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('rocheCount', true)
  }, [_vm._v("罗氏员工人数（内）"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.rocheCount))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "field-block"
  }, [_c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('totalAmount', true)
  }, [_vm._v("会议总预算(CNY)"), _c('common-tooltip', {
    staticClass: "field-input-no-title-tooltip",
    attrs: {
      "isView": "",
      "tipCode": "12"
    }
  }), _c('span', [_vm._v("*")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.totalAmount))])]), _vm._v(" "), (_vm.addNewOrEditData.meetingSystem.length == 2) ? _c('div', [_c('div', {
    staticClass: "field-row-inner"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addNewOrEditData.meetingSystem.length == 2),
      expression: "addNewOrEditData.meetingSystem.length == 2"
    }],
    staticClass: "field-title",
    class: _vm.required('a1Amount', _vm.addNewOrEditData.meetingSystem.length == 2)
  }, [_vm._v("A1预算"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.a1Amount))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row-inner"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addNewOrEditData.meetingSystem.length == 2),
      expression: "addNewOrEditData.meetingSystem.length == 2"
    }],
    staticClass: "field-title",
    class: _vm.required('gsdAmount', _vm.addNewOrEditData.meetingSystem.length == 2)
  }, [_vm._v("GSD预算"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.gsdAmount))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title",
    class: _vm.required('costCenter', true)
  }, [_vm._v("成本中心"), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.costCenter + ' ' + _vm.addNewOrEditData.costCenterName))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title"
  }, [_vm._v("WBS code")]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.wbsCode))])]), _vm._v(" "), _c('div', {
    staticClass: "field-row"
  }, [_c('div', {
    staticClass: "field-title"
  }, [_vm._v("会议申请人")]), _vm._v(" "), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.meetingOrganizerCnname + ' ' + _vm.addNewOrEditData.meetingOrganizerName))])])]), _vm._v(" "), _c('div', {
    staticClass: "workflow",
    on: {
      "click": function($event) {
        _vm.showWorkflow = !_vm.showWorkflow
      }
    }
  }, [_c('div', {
    staticClass: "workflow-dropdown-icon"
  }, [_c('span', {
    class: ['iconfont', _vm.showWorkflow ? 'icon-jiantou_shang' : 'icon-jiantou_xia']
  })]), _vm._v(" "), _c('span', {
    staticClass: "workflow-title"
  }, [_vm._v("审批流")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWorkflow),
      expression: "showWorkflow"
    }],
    staticClass: "field-block"
  }, _vm._l((_vm.addNewOrEditData.nodeList), function(node, index) {
    return _c('div', {
      key: node.id
    }, [_c('div', {
      class: ['field-row-inner', index == 0 ? 'field-row-first' : '']
    }, [_c('div', {
      staticClass: "field-title field-title-status"
    }, [_vm._v(_vm._s(node.nodeLevel))])]), _vm._v(" "), _c('div', {
      class: ['field-row-inner', (!node.remark && index == _vm.addNewOrEditData.nodeList.length - 1) ? 'field-row-last' : '']
    }, [_c('div', {
      staticClass: "field-value field-value-left field-value-status"
    }, [_vm._v(_vm._s(node.realName) + " " + _vm._s(node.username)), _c('br'), _vm._v(_vm._s(_vm._f("TimeFormat")(node.createTime)))]), _vm._v(" "), _c('span', {
      class: ['approval-status', _vm.approvalStatusClass(node.meetStatus)]
    }, [_vm._v(_vm._s(node.statusName))])]), _vm._v(" "), (node.remark) ? _c('div', {
      class: ['field-row-inner', (index == _vm.addNewOrEditData.nodeList.length - 1) ? 'field-row-last' : '']
    }, [_c('div', {
      staticClass: "field-value field-value-left field-value-status"
    }, [_vm._v(_vm._s(node.remark))])]) : _vm._e()])
  }), 0), _vm._v(" "), (((_vm.addNewOrEditData.status == '5' || _vm.addNewOrEditData.status == '8') && _vm.addNewOrEditData.isAutoReject !== '1')) ? _c('div', {
    staticClass: "bottom-info"
  }, [_c('mt-button', {
    attrs: {
      "type": "primary",
      "loading": false
    },
    on: {
      "click": _vm.handlerChangeClick
    }
  }, [_vm._v("变更")])], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f3df5218", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3df5218","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/meetingplan/application/view/index.vue
// module id = 768
// module chunks = 7